import { PlayerWorkBox, PlayerWorkBoxProps } from "./PlayerWorkBox";
import { MeetingSession, MeetingSessionHighlightingState, MeetingSessionMedia } from "@kalyzee/kast-web-sdk/websocket";
import React from "react";
import { getNormalUser } from "../../helpers/user";


export interface SlavePlayerWorkBoxProps {
  ownSession: MeetingSession;
  children: React.ReactNode;
  meetingOngoing?: boolean;
  session: MeetingSession;
  mediaSession: MeetingSessionMedia;
  topBarMode?: PlayerWorkBoxProps["overlayMode"];
  isSmall?: boolean;
  isPlayingSound?: boolean;
  mediaControls?: boolean;
}

const _SlavePlayerWorkBox: React.FC<SlavePlayerWorkBoxProps> = ({
  ownSession,
  children,
  meetingOngoing,
  session,
  mediaSession,
  topBarMode = "permanent",
  isSmall,
  isPlayingSound,
  mediaControls,
}) => {
  const isMe = ownSession?.id === session.id;
  const { displayName, avatar } = session.user ? getNormalUser(session.user) : { displayName: undefined, avatar: undefined };

  const getTopBarLabel = () => {
    if (isMe) return "Vous";
    return displayName ?? "Utilisateur";
  };

  const getTobBarLabelInfo = () => {
    if (isSmall) return undefined;
    let label = mediaSession.extra?.label ?? "webcam";
    return label.charAt(0).toUpperCase() + label.slice(1);
  };

  const videoEnabled = mediaSession.video?.enabled ?? false;
  const audioEnabled = mediaSession.audio?.enabled ?? false;

  return (
    <PlayerWorkBox
      label={getTopBarLabel()}
      labelInfo={getTobBarLabelInfo()}
      userDisplayName={displayName}
      avatar={avatar}
      overlayMode="overlay"
      video={mediaControls ? videoEnabled : undefined}
      audio={mediaControls ? audioEnabled : undefined}
      isMe={isMe}
      isHighlighted={session.highlighting === MeetingSessionHighlightingState.ONGOING}
      isPlayingSound={isPlayingSound}
      idleAnimation={!meetingOngoing}
    >
      {children}
    </PlayerWorkBox>
  );
};

export const SlavePlayerWorkBox = React.memo(_SlavePlayerWorkBox);